import React, { createContext, useContext, useEffect, useState } from "react";

const STR = {
  /* Navigation */
  "nav.directory": { en: "Directory", es: "Directorio" },
  "nav.plants": { en: "Suppliers", es: "Proveedores" },
  "nav.digest": { en: "Digest", es: "Digest" },
  "nav.pricing": { en: "Pricing", es: "Precios" },
  "nav.login": { en: "Sign in", es: "Iniciar sesión" },
  "nav.signup": { en: "List your factory", es: "Lista tu planta" },
  "nav.dashboard": { en: "Dashboard", es: "Panel" },
  "nav.logout": { en: "Sign out", es: "Cerrar sesión" },

  /* Landing */
  "landing.kicker": { en: "Chihuahua ↔ El Paso · Juárez · Parral · Chihuahua City", es: "Chihuahua ↔ El Paso · Juárez · Parral · Chihuahua City" },
  "landing.hero1": {
    en: "The corridor's IMMEX manufacturers, finally on the record.",
    es: "Los fabricantes IMMEX del corredor, por fin en el registro.",
  },
  "landing.hero2": {
    en: "A bilingual directory, document vault and inquiry channel built for cross-border procurement between US buyers and mid-size Mexican manufacturers.",
    es: "Un directorio bilingüe, bóveda de documentos y canal de cotizaciones diseñado para la compra-venta transfronteriza entre compradores estadounidenses y maquiladoras mexicanas.",
  },
  "landing.cta.primary": { en: "List your factory", es: "Lista tu planta" },
  "landing.cta.secondary": { en: "Browse suppliers", es: "Explorar proveedores" },
  "landing.stats.title": { en: "What the corridor moves", es: "Lo que mueve el corredor" },
  "landing.stats.s1.k": { en: "USD daily trade", es: "USD comercio diario" },
  "landing.stats.s1.v": { en: "$2.3B", es: "$2.3B" },
  "landing.stats.s2.k": { en: "IMMEX plants in Juárez", es: "Plantas IMMEX en Juárez" },
  "landing.stats.s2.v": { en: "330+", es: "330+" },
  "landing.stats.s3.k": { en: "US procurement gap", es: "Brecha compras EE.UU." },
  "landing.stats.s3.v": { en: "Real", es: "Real" },
  "landing.stats.s4.k": { en: "Bilingual platforms", es: "Plataformas bilingües" },
  "landing.stats.s4.v": { en: "One.", es: "Una." },

  "landing.problem.kicker": { en: "The asymmetry", es: "La asimetría" },
  "landing.problem.title": {
    en: "US buyers can't find you. Your Mexican plant can't be discovered.",
    es: "Los compradores en EE.UU. no te encuentran. Tu planta no es descubierta.",
  },
  "landing.problem.body": {
    en: "Procurement managers in Texas, New Mexico and Arizona type 'CNC machining Juárez' into Google and find scrap. Meanwhile, the plant that could fulfill their RFQ is two highway exits south — with no bilingual web presence, no document portal, no inquiry channel. Corridor Digital fixes that.",
    es: "Los gerentes de compras en Texas, Nuevo México y Arizona buscan 'maquinado CNC Juárez' en Google y encuentran nada útil. Mientras tanto, la planta que podría fabricar su requerimiento está a dos salidas de la autopista — sin presencia web bilingüe, sin portal de documentos, sin canal de cotizaciones. Corridor Digital resuelve eso.",
  },

  "landing.what.kicker": { en: "What you get", es: "Lo que obtienes" },
  "landing.what.title": {
    en: "Three tools, one platform.",
    es: "Tres herramientas, una plataforma.",
  },
  "landing.what.f1.t": { en: "Corporate microsite", es: "Micrositio corporativo" },
  "landing.what.f1.d": {
    en: "A bilingual profile page that looks like a real spec sheet — capabilities, certifications, plant size, contact. Shareable URL.",
    es: "Una ficha bilingüe que se ve como una hoja técnica real — capacidades, certificaciones, tamaño de planta, contacto. URL para compartir.",
  },
  "landing.what.f2.t": { en: "Compliance vault", es: "Bóveda de cumplimiento" },
  "landing.what.f2.d": {
    en: "Upload IMMEX permits, USMCA certificates, ISO docs. Generate secure, time-limited share links for US buyers — no login required.",
    es: "Sube permisos IMMEX, certificados USMCA, documentos ISO. Genera enlaces seguros con caducidad para compradores estadounidenses — sin necesidad de cuenta.",
  },
  "landing.what.f3.t": { en: "Inquiry channel", es: "Canal de cotizaciones" },
  "landing.what.f3.d": {
    en: "US buyers send RFQs from your profile straight to your inbox. Track who opened what, when. Reply in either language.",
    es: "Los compradores envían cotizaciones desde tu perfil directo a tu bandeja. Rastrea quién abrió qué y cuándo. Responde en cualquier idioma.",
  },

  "landing.buyers.kicker": { en: "If you're a US buyer", es: "Si eres comprador en EE.UU." },
  "landing.buyers.title": {
    en: "Find vetted IMMEX manufacturers without flying down.",
    es: "Encuentra fabricantes IMMEX verificados sin tener que volar.",
  },
  "landing.buyers.body": {
    en: "Browse the directory free. Filter by capability, certification, plant size. Request documents and quotes directly. No middleman.",
    es: "Explora el directorio gratis. Filtra por capacidad, certificación, tamaño de planta. Solicita documentos y cotizaciones directamente. Sin intermediarios.",
  },
  "landing.buyers.cta": { en: "Browse the directory", es: "Explorar el directorio" },

  "landing.pricing.kicker": { en: "Manufacturers", es: "Fabricantes" },
  "landing.pricing.title": {
    en: "Three tiers. Built for the corridor.",
    es: "Tres planes. Hecho para el corredor.",
  },
  "landing.pricing.cta": { en: "See pricing", es: "Ver precios" },

  "landing.footer.line": {
    en: "Built in the corridor. For the corridor.",
    es: "Hecho en el corredor. Para el corredor.",
  },

  /* Brief A — Homepage Hero v2 */
  "ba.hero.headline": {
    en: "The First and Only Verified Bilingual IMMEX Supplier Directory in the Chihuahua–El Paso Corridor (Juárez, Parral, Chihuahua City)",
    es: "El Primer y Único Directorio Bilingüe de Proveedores IMMEX en el Corredor Chihuahua–El Paso (Juárez, Parral, Chihuahua City)",
  },
  "ba.hero.subheadline": {
    en: "330+ IMMEX plants. US buyers ready to source. Zero middlemen.",
    es: "Más de 330 plantas IMMEX. Compradores estadounidenses listos para sourcing. Sin intermediarios.",
  },
  "ba.hero.cta.find": { en: "Find a Supplier", es: "Buscar Proveedor" },
  "ba.hero.cta.list": { en: "List Your Plant", es: "Registrar mi Planta" },
  "ba.hero.cta.wa": {
    en: "Are you a plant owner? List via WhatsApp →",
    es: "¿Eres dueño de planta? Registrarme por WhatsApp →",
  },

  /* Brief A — Live Social Proof Strip */
  "ba.sp.plants": { en: "IMMEX Plants Listed", es: "Plantas IMMEX Registradas" },
  "ba.sp.rfqs_week": { en: "RFQs Submitted This Week", es: "Cotizaciones esta Semana" },
  "ba.sp.signups_month": { en: "Field Signups This Month", es: "Registros en Campo Este Mes" },
  "ba.sp.fallback": {
    en: "Growing daily – be the first in your park",
    es: "Creciendo cada día – sé el primero en tu parque",
  },

  /* Brief A — Trust Signals */
  "ba.ts.immex": { en: "Government-listed IMMEX Suppliers", es: "Proveedores IMMEX Listados por Gobierno" },
  "ba.ts.corridor": { en: "Chihuahua–El Paso Corridor", es: "Corredor Chihuahua–El Paso" },
  "ba.ts.usmca": { en: "USMCA Compliant Trade Zone", es: "Zona Comercial USMCA" },
  "ba.ts.first": { en: "Est. 2025", es: "Est. 2025" },

  /* Brief A — Why You Can't Find This Anywhere Else */
  "ba.why.kicker": {
    en: "Why You Can't Find This Anywhere Else",
    es: "Por Qué No Encontrarás Esto en Otro Lado",
  },
  "ba.why.c1.h": { en: "Government-listed IMMEX", es: "IMMEX listado por gobierno" },
  "ba.why.c1.b": {
    en: "Every plant record comes from the official Mexican government IMMEX listing. Corridor verification status is always shown separately — never conflated.",
    es: "Cada registro de planta proviene del listado oficial IMMEX del gobierno mexicano. El estatus de verificación Corridor siempre se muestra por separado — nunca se mezcla.",
  },
  "ba.why.c2.h": { en: "Bilingual by Design", es: "Bilingüe por Diseño" },
  "ba.why.c2.b": {
    en: "US buyers search in English. Plant owners operate in Spanish. Corridor Digital speaks both — no translation friction, no lost deals.",
    es: "Los compradores en EE.UU. buscan en inglés. Los dueños de planta operan en español. Corridor Digital habla los dos — sin fricción, sin tratos perdidos.",
  },
  "ba.why.c3.h": { en: "Direct RFQs", es: "Cotizaciones directas" },
  "ba.why.c3.b": {
    en: "US buyers submit RFQs directly through the platform and plants receive them in their inbox. No email chains, no middlemen.",
    es: "Los compradores envían cotizaciones directamente por la plataforma y las plantas las reciben en su bandeja. Sin cadenas de correos, sin intermediarios.",
  },

  /* Brief A — /plants directory */
  "plants.title": { en: "Plant Directory", es: "Directorio de Plantas" },
  "plants.subtitle": {
    en: "IMMEX manufacturers on the Juárez–El Paso corridor. Based on the official IMMEX listing and cited research evidence.",
    es: "Fabricantes IMMEX del corredor Juárez–El Paso. Basado en el listado oficial IMMEX y evidencia de investigación citada.",
  },
  "plants.search": {
    en: "Search by capability, park, or plant name…",
    es: "Buscar por capacidad, parque o nombre de planta…",
  },
  "plants.filter.all": { en: "All", es: "Todos" },
  "plants.sort.recent": { en: "Most Recent", es: "Más Recientes" },
  "plants.sort.fastest": { en: "Fastest Response", es: "Respuesta más Rápida" },
  "plants.sort.most_rfqs": { en: "Most RFQs", es: "Más Cotizaciones" },
  "plants.card.cta": { en: "Request a Quote", es: "Solicitar Cotización" },
  "plants.card.responds_in": { en: "Responds in", es: "Responde en" },
  "plants.empty.title": {
    en: "No suppliers in this category yet",
    es: "Aún no hay proveedores en esta categoría",
  },
  "plants.empty.cta": {
    en: "Get notified when one joins",
    es: "Recibir aviso cuando entre uno",
  },
  "plants.waitlist.title": { en: "Notify me when a match joins", es: "Avísame cuando entre una planta" },
  "plants.waitlist.email": { en: "Your work email", es: "Tu correo de trabajo" },
  "plants.waitlist.submit": { en: "Join Waitlist", es: "Unirme a la Lista" },
  "plants.waitlist.success": {
    en: "You're on the list. We'll email you when a plant matches.",
    es: "Estás en la lista. Te avisaremos cuando entre una planta que coincida.",
  },

  /* Brief A — /plants/[slug] profile */
  "pl.verified": { en: "IMMEX listed", es: "IMMEX listado" },
  "pl.responds": { en: "Typically responds within", es: "Responde típicamente en" },
  "pl.share": { en: "Share this Supplier", es: "Compartir este Proveedor" },
  "pl.copied": { en: "Link copied!", es: "¡Enlace copiado!" },
  "pl.rfq_cta": { en: "Request a Quote", es: "Solicitar Cotización" },
  "pl.contact_after_rfq": {
    en: "Contact info shown after you submit an RFQ.",
    es: "La información de contacto se muestra después de enviar una cotización.",
  },
  "pl.location_label": { en: "Location", es: "Ubicación" },
  "pl.maps": { en: "Open in Google Maps", es: "Abrir en Google Maps" },

  /* Pricing */
  "pricing.title": { en: "Plans built for IMMEX manufacturers.", es: "Planes hechos para fabricantes IMMEX." },
  "pricing.subtitle": {
    en: "Pay monthly. Cancel anytime. 60-day onboarding free for in-person signups.",
    es: "Paga mensual. Cancela cuando quieras. 60 días de onboarding gratis para registros en persona.",
  },
  "pricing.free.name": { en: "Listed", es: "Registrado" },
  "pricing.free.tag": { en: "Free", es: "Gratis" },
  "pricing.free.price": { en: "$0", es: "$0" },
  "pricing.pro.name": { en: "Pro", es: "Pro" },
  "pricing.pro.tag": { en: "Corridor Verified", es: "Corredor Verificado" },
  "pricing.pro.price": { en: "$199", es: "$199" },
  "pricing.premium.name": { en: "Premium", es: "Premium" },
  "pricing.premium.tag": { en: "Featured Supplier", es: "Proveedor Destacado" },
  "pricing.premium.price": { en: "$599", es: "$599" },
  "pricing.per_month": { en: "/ month", es: "/ mes" },
  "pricing.cta.free": { en: "Get listed free", es: "Listar gratis" },
  "pricing.cta.upgrade": { en: "Upgrade", es: "Mejorar" },
  "pricing.current": { en: "Current plan", es: "Plan actual" },

  /* Auth */
  "auth.login.title": { en: "Sign in", es: "Iniciar sesión" },
  "auth.register.title": { en: "Create your factory account", es: "Crea la cuenta de tu planta" },
  "auth.email": { en: "Email", es: "Correo" },
  "auth.password": { en: "Password", es: "Contraseña" },
  "auth.name": { en: "Your name", es: "Tu nombre" },
  "auth.submit.login": { en: "Sign in", es: "Iniciar sesión" },
  "auth.submit.register": { en: "Create account", es: "Crear cuenta" },
  "auth.google": { en: "Continue with Google", es: "Continuar con Google" },
  "auth.or": { en: "or", es: "o" },
  "auth.have_account": { en: "Already have an account?", es: "¿Ya tienes cuenta?" },
  "auth.no_account": { en: "No account yet?", es: "¿Aún no tienes cuenta?" },

  /* Dashboard */
  "dash.welcome": { en: "Operations", es: "Operaciones" },
  "dash.profile_views": { en: "Profile views", es: "Vistas de perfil" },
  "dash.inquiries": { en: "New inquiries", es: "Nuevas cotizaciones" },
  "dash.documents": { en: "Documents on file", es: "Documentos archivados" },
  "dash.expiring": { en: "Expiring soon", es: "Por vencer" },
  "dash.completeness": { en: "Profile completeness", es: "Perfil completado" },
  "dash.share_links": { en: "Active share links", es: "Enlaces activos" },
  "dash.publish_warning": {
    en: "Your profile is unpublished. US buyers cannot find you.",
    es: "Tu perfil no está publicado. Los compradores no pueden encontrarte.",
  },
  "dash.publish_cta": { en: "Publish profile", es: "Publicar perfil" },
  "dash.view_public": { en: "View public profile", es: "Ver perfil público" },
  "dash.actions": { en: "Shortcuts", es: "Atajos" },
  "dash.letterTitle": { en: "Letter of Listing", es: "Carta de Listado" },
  "dash.letterSub": { en: "Print / save PDF to share with buyers", es: "Imprimir / guardar PDF para compradores" },

  /* Profile editor */
  "profile.title": { en: "Company profile", es: "Perfil de la empresa" },
  "profile.company_name": { en: "Company name", es: "Nombre de la empresa" },
  "profile.tagline": { en: "Tagline / one-liner", es: "Lema / frase principal" },
  "profile.description": { en: "Description", es: "Descripción" },
  "profile.capabilities": { en: "Capabilities (comma separated)", es: "Capacidades (separadas por coma)" },
  "profile.certifications": { en: "Certifications", es: "Certificaciones" },
  "profile.industries": { en: "Industries served", es: "Industrias atendidas" },
  "profile.city": { en: "City", es: "Ciudad" },
  "profile.state": { en: "State", es: "Estado" },
  "profile.country": { en: "Country", es: "País" },
  "profile.year_founded": { en: "Year founded", es: "Año de fundación" },
  "profile.employees": { en: "Employees", es: "Empleados" },
  "profile.plant_size": { en: "Plant size (m²)", es: "Tamaño de planta (m²)" },
  "profile.website": { en: "Website", es: "Sitio web" },
  "profile.contact_email": { en: "Contact email", es: "Correo de contacto" },
  "profile.contact_phone": { en: "Contact phone", es: "Teléfono de contacto" },
  "profile.logo_url": { en: "Logo URL", es: "URL del logo" },
  "profile.cover_url": { en: "Cover image URL", es: "URL de imagen de portada" },
  "profile.gallery": { en: "Gallery image URLs (one per line)", es: "URLs de galería (una por línea)" },
  "profile.publish": { en: "Publish profile", es: "Publicar perfil" },
  "profile.save": { en: "Save changes", es: "Guardar cambios" },
  "profile.translate_es_en": { en: "Auto-translate ES→EN", es: "Traducir ES→EN" },
  "profile.translate_en_es": { en: "Auto-translate EN→ES", es: "Traducir EN→ES" },
  "profile.spanish": { en: "Spanish", es: "Español" },
  "profile.english": { en: "English", es: "Inglés" },
  "profile.legalEntity": { en: "Legal entity & trust signals", es: "Entidad legal y señales de confianza" },
  "profile.legalEntityHint": {
    en: "Optional. Adds an RFC-masked trust block to your microsite and the Letter of Listing PDF.",
    es: "Opcional. Agrega un bloque de confianza con RFC enmascarado a tu micrositio y a la Carta de Listado PDF.",
  },
  "profile.legal_name": { en: "Razón Social (legal name)", es: "Razón Social" },
  "profile.rfc": { en: "RFC", es: "RFC" },
  "profile.immex_number": { en: "IMMEX number", es: "Número IMMEX" },
  "profile.padron_number": { en: "Padrón de Importadores", es: "Padrón de Importadores" },
  "profile.duns_number": { en: "D-U-N-S number", es: "Número D-U-N-S" },

  /* Documents */
  "docs.title": { en: "Compliance vault", es: "Bóveda de cumplimiento" },
  "docs.new": { en: "Add document", es: "Agregar documento" },
  "docs.name": { en: "Document name", es: "Nombre del documento" },
  "docs.category": { en: "Category", es: "Categoría" },
  "docs.issued": { en: "Issued", es: "Emitido" },
  "docs.expires": { en: "Expires", es: "Vence" },
  "docs.file": { en: "File (optional, max 10MB)", es: "Archivo (opcional, máx 10MB)" },
  "docs.notes": { en: "Notes", es: "Notas" },
  "docs.empty": { en: "No documents yet. Add your first one.", es: "Sin documentos aún. Agrega el primero." },
  "docs.share": { en: "Share with buyer", es: "Compartir con comprador" },
  "docs.delete": { en: "Delete", es: "Eliminar" },
  "docs.download": { en: "Download", es: "Descargar" },

  /* Share */
  "share.title": { en: "Create share link", es: "Crear enlace para compartir" },
  "share.recipient_email": { en: "Recipient email (optional)", es: "Correo del destinatario (opcional)" },
  "share.recipient_company": { en: "Recipient company (optional)", es: "Empresa del destinatario (opcional)" },
  "share.note": { en: "Note for recipient", es: "Nota para el destinatario" },
  "share.expires_in": { en: "Expires in (days)", es: "Vence en (días)" },
  "share.create": { en: "Create link", es: "Crear enlace" },
  "share.copy": { en: "Copy link", es: "Copiar enlace" },
  "share.copied": { en: "Copied!", es: "¡Copiado!" },
  "share.active": { en: "Active share links", es: "Enlaces activos" },
  "share.public.title": { en: "Confidential document share", es: "Compartición confidencial" },
  "share.public.note": { en: "From the manufacturer", es: "Del fabricante" },

  /* Inquiries */
  "inq.title": { en: "Inquiries", es: "Cotizaciones" },
  "inq.empty": { en: "No inquiries yet.", es: "Sin cotizaciones aún." },
  "inq.from": { en: "From", es: "De" },
  "inq.subject": { en: "Subject", es: "Asunto" },
  "inq.quantity": { en: "Quantity", es: "Cantidad" },
  "inq.timeline": { en: "Timeline", es: "Plazo" },
  "inq.mark_read": { en: "Mark read", es: "Marcar leído" },
  "inq.archive": { en: "Archive", es: "Archivar" },

  /* Public directory */
  "dir.title": { en: "Manufacturer directory", es: "Directorio de fabricantes" },
  "dir.search": { en: "Search capabilities, certifications, products…", es: "Buscar capacidades, certificaciones, productos…" },
  "dir.filter.capability": { en: "Capability", es: "Capacidad" },
  "dir.filter.certification": { en: "Certification", es: "Certificación" },
  "dir.filter.industry": { en: "Industry", es: "Industria" },
  "dir.filter.city": { en: "City", es: "Ciudad" },
  "dir.verified_only": { en: "Verified only", es: "Solo verificados" },
  "dir.results": { en: "results", es: "resultados" },
  "dir.empty": { en: "No manufacturers match those filters yet.", es: "Aún no hay fabricantes que coincidan con esos filtros." },
  "dir.view": { en: "View profile", es: "Ver perfil" },

  /* Public profile */
  "pp.contact": { en: "Request information", es: "Solicitar información" },
  "pp.verified": { en: "Corridor Verified", es: "Corredor Verificado" },
  "pp.featured": { en: "Featured Supplier", es: "Proveedor Destacado" },
  "pp.capabilities": { en: "Capabilities", es: "Capacidades" },
  "pp.certifications": { en: "Certifications", es: "Certificaciones" },
  "pp.industries": { en: "Industries", es: "Industrias" },
  "pp.specs": { en: "Plant specs", es: "Especificaciones de planta" },
  "pp.location": { en: "Location", es: "Ubicación" },
  "pp.employees": { en: "Employees", es: "Empleados" },
  "pp.year_founded": { en: "Founded", es: "Fundada" },
  "pp.plant_size": { en: "Plant size", es: "Tamaño de planta" },
  "pp.legalEntity": { en: "Legal entity", es: "Entidad legal" },
  "pp.verifiedEntity": { en: "Verified entity", es: "Entidad verificada" },
  "pp.rfcMaskedNote": {
    en: "RFC partially masked for privacy. Full value available on signed Letter of Listing.",
    es: "RFC parcialmente enmascarado por privacidad. Valor completo disponible en Carta de Listado firmada.",
  },
  "pp.send": { en: "Send inquiry", es: "Enviar cotización" },
  "pp.your_name": { en: "Your name", es: "Tu nombre" },
  "pp.your_email": { en: "Your email", es: "Tu correo" },
  "pp.your_company": { en: "Your company", es: "Tu empresa" },
  "pp.subject_h": { en: "Subject", es: "Asunto" },
  "pp.message_h": { en: "Message", es: "Mensaje" },
  "pp.quantity_h": { en: "Estimated quantity (optional)", es: "Cantidad estimada (opcional)" },
  "pp.timeline_h": { en: "Timeline (optional)", es: "Plazo (opcional)" },
  "pp.sent.title": { en: "Inquiry sent.", es: "Cotización enviada." },
  "pp.sent.body": { en: "The manufacturer will respond to your email.", es: "El fabricante responderá a tu correo." },

  /* Common */
  "common.required": { en: "Required", es: "Requerido" },
  "common.cancel": { en: "Cancel", es: "Cancelar" },
  "common.save": { en: "Save", es: "Guardar" },
  "common.loading": { en: "Loading…", es: "Cargando…" },
  "common.error": { en: "Something went wrong.", es: "Algo salió mal." },
  "common.translate": { en: "Translate", es: "Traducir" },
  "common.translating": { en: "Translating…", es: "Traduciendo…" },
  "common.published": { en: "Published", es: "Publicado" },
  "common.unpublished": { en: "Unpublished", es: "Sin publicar" },
};

const I18nCtx = createContext(null);

export function I18nProvider({ children }) {
  const [lang, setLang] = useState(() => {
    if (typeof window === "undefined") return "en";
    return localStorage.getItem("cd_lang") || "es";
  });
  useEffect(() => {
    localStorage.setItem("cd_lang", lang);
    document.documentElement.lang = lang;
  }, [lang]);
  const t = (key, fallback = "") => {
    const entry = STR[key];
    if (!entry) return fallback || key;
    return entry[lang] ?? entry.en ?? fallback ?? key;
  };
  return (
    <I18nCtx.Provider value={{ lang, setLang, t }}>{children}</I18nCtx.Provider>
  );
}

export function useI18n() {
  const ctx = useContext(I18nCtx);
  if (!ctx) throw new Error("useI18n outside provider");
  return ctx;
}
